// stage.ver="1.0.0";
// stage.languageList="zh,en";//支持的国际化种类
stage.loc.customer = "SOLARMAN"; //oem客户的名称
$.extend(true, stage.loc, {
	logo: {
		login: { public: "/static/image/logo.png" },
		system: { public: "/static/image/logo.png" },
	},
	customerDisplay: {
		//用来展示的定制化名称
		public: "SAPN Monitor",
	},
	platformName: "小麦商家版", //平台名称
	platformCode: "SOLARMAN_BUSINESS", //后端定义的平台code
	operationManual: {
		public: "https://doc.solarmanpv.com/web/#/4",
		zh: "https://doc.solarmanpv.com/web/#/2",
	},
	statistic: {
		//网站统计代码地址
		baidu: "https://hm.baidu.com/hm.js?dbf2c5125388475c6bbd8e763961be8a",
	},
	key: {
		//各种第三方api的key
		// SOLARMAN:{
		// amap:"",
		google: "AIzaSyDVGGzvlaK95N6aKYujuolak6EtfxxV0wA", //AIzaSyCesEqmd-_MPYsZUlCC3RmKebNZXtaHoVA
		// }
	},
});
$.extend(true, stage.setting.loc, {
	privacyStatementUrl: {
		// 服务协议声明的跳转链接
		public: "http://www.solarman.cn/en/privacy.html",
		zh: "http://www.solarman.cn/privacy.html",
	},
	privacyPolicyUrl: {
		// 隐私协议声明的跳转链接
		public: "https://protocol.solarmanpv.com/SOLARMAN/privacy_en.html",
		zh: "https://protocol.solarmanpv.com/SOLARMAN/privacy_cn.html",
	},
	shieldWhiteList: {
		Announcement: true,
		app: {
			electricity: true,
			distributions: true,
			IVCurveItemStruct: true, //IV曲线
		},
		mapMode: {
			plant: true,
		},
		orderManagement: true, //指令管理
	},
});
$.extend(true, stage.setting, {
	routeTrigger: {
		"/application/deviceControl": (function () {
			let out = "";
			switch (stage.envi) {
				case "dev":
					out = location.protocol + "//" + "dc.dev.igen/application/deviceControl";
					break;
				case "test":
					out = location.protocol + "//" + "dc.f-qa.igen/application/deviceControl";
					break;
				case "pro":
					out = location.protocol + "//" + "dc.solarmanpv.com/application/deviceControl";
					break;
			}
			return out;
		})(),
	},
});



// WEBPACK FOOTER //
// ./src/oem/js/SOLARMAN.js